import { ReactNode, useEffect, useState } from 'react';
import useTranslation from '../hooks/useTranslation';
import Cross from './icons/Cross';
import { useRef } from 'react';

type WidgetDialog = {
  children: ReactNode;
  closeModal: () => void;
};

const WidgetDialog = ({ children, closeModal }: WidgetDialog) => {
  const { SRCloseModal } = useTranslation();
  const containerRef = useRef<HTMLDialogElement | null>(null);

  useEffect(() => {
    const dialog = containerRef?.current;
    if (dialog && !dialog.open && dialog.isConnected) {
      dialog?.showModal();
    }
    return () => {
      if (dialog && dialog.open) {
        dialog?.close();
      }
    };
  }, []);

  return (
    <dialog
      ref={containerRef}
      className={
        'fixed backdrop-blur-xs backdrop:bg-black/10 bg-transparent h-full w-full max-w-full max-h-full inset-0 overscroll-none overflow-y-scroll flex flex-col  items-center z-9999 font-widget'
      }
      onClick={() => {
        closeModal();
      }}
      aria-modal="true"
      aria-labelledby="title"
      aria-describedby="subtitle"
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          closeModal();
        }
      }}
    >
      <div
        className={`relative w-full bg-secondaryBackground rounded-[20px] drop-shadow-2xl max-w-4xl my-6 md:my-12 py-4 sm:py-8 text-neutral-700 text-left`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div className={'flex justify-end px-4 sm:px-8'}>
          <button aria-label={SRCloseModal} onClick={() => closeModal()}>
            <Cross />
            <span className="sr-only">{SRCloseModal}</span>
          </button>
        </div>
        {children}
      </div>
    </dialog>
  );
};

export default WidgetDialog;
